import React from "react";

import { baseUrl } from '../../constants/backendUrls';

const Contact = props => {

    const classList = ["contact"];

    if (props.isActive) {
        classList.push("contact--active");
    }

    return (
        <div className={classList.join(' ')} onClick={props.clicked}>
            <div className="contact-content">
                <div className="contact-image">
                    <img src={`${baseUrl}/${props.profilePicture}`} alt="Contact" />
                </div>
                <div className="contact-info">
                    <p className={props.hasUnreadMessage ? "contact-info__name contact-info__name--bold" : "contact-info__name"}>{props.name}</p>
                    <p className={props.hasUnreadMessage ? "contact-info__last-message contact-info__last-message--bold" : "contact-info__last-message"}> {props.lastMessage}</p>
                </div>
            </div>

            <div className={props.hasUnreadMessage ? "contact__new-message contact__new-message--show" : "contact__new-message"}></div>
        </div >
    );
}

export default Contact;